export enum LiveFeedEncryptionTypeEnum {
  None,
  AES128,
  AES192,
  AES256,
}

export class LiveFeed {
  constructor(
    public id: string,
    public name: string,
    public tenantUniqueId: string,
    public thumbnail: string,
  ) {}
}

export enum EStreamSourceType {
  ZIXI_PUSH,
  ZIXI_PULL,
  RTMP_PUSH,
  RTMP_PULL,
  HLS_PULL,
  DASH_PULL,
  RTSP_PULL,
  SRT_PULL,
  SRT_PUSH,
  TCP_PULL,
  TCP_PUSH,
}

export class StreamSourceSettings {
  constructor(
    public sourceType: EStreamSourceType,
    public encryptionType: LiveFeedEncryptionTypeEnum,
    public encryptionKey: string,
    public username: string,
    public password: string,
    public remoteAddress: string,
    public remotePort: number,
    public localPort: number,
    public url: string,
    public streamName: string,
    public zixiRemoteName: string,
    public protocolLatencyMs: number,
    public specialOptions: string,
    public whitelistIpRanges: string[],
  ) {}
}

export class StreamingPlatform {
  constructor(
    public id: number,
    public privateIp: string,
    public publicIp: string,
    public availabilityZoneId: number,
    public availabilityZoneName: string,
  ) {}
}

export class LiveFeedStreamingPlatform extends StreamingPlatform {
  constructor(
    id: number,
    privateIp: string,
    publicIp: string,
    availabilityZoneId: number,
    availabilityZoneName: string,
    public streamSourceSettings: StreamSourceSettings,
  ) {
    super(id, privateIp, publicIp, availabilityZoneId, availabilityZoneName);
  }
}

export class LiveFeedInfo extends LiveFeed {
  constructor(
    id: string,
    name: string,
    public tenantUniqueId: string,
    public thumbnail: string,
    public metadata: { name: string; value: string }[],
    public tagIds: number[],
    public frameFormat: number,
    public internalLatencyMs: number,
    public totalLatencyMs: number,
    public streamingPlatforms: LiveFeedStreamingPlatform[],
  ) {
    super(id, name, tenantUniqueId, thumbnail);
  }
}
